import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 18,
  steps: [
    addColumns({
      table: 'chats',
      columns: [
        { name: 'client_summary', type: 'string', isOptional: true },
        { name: 'client_summary_at', type: 'number', isOptional: true },
        { name: 'is_client_summarizing', type: 'boolean' },
        { name: 'show_client_summary', type: 'boolean' }
      ]
    })
  ]
}
